import { specialCountries } from "./const";
import { getCountryName } from "./formatNames";

function isStateLevelCountry(countryName?: string): boolean {
  const country = countryName?.trim();
  if (!country) {
    return false;
  }
  return specialCountries.includes(country);
}

/**
 * Member search firm location:
 * - USA, Canada, China: state + country (no city)
 * - Rest of world: city + country
 */
export function formatMemberSearchFirmLocation(
  cityName?: string,
  stateName?: string,
  countryName?: string,
): string {
  const city = cityName?.trim();
  const state = stateName?.trim();
  const country = countryName?.trim();

  if (country && isStateLevelCountry(country)) {
    if (state) {
      return `${state}, ${getCountryName(country)}`;
    }
    return getCountryName(country);
  }

  if (city && country) {
    return `${city}, ${getCountryName(country)}`;
  }
  if (city) {
    return city;
  }
  if (country) {
    return getCountryName(country);
  }
  return "";
}
